import * as React from 'react';
import { Form, Row, Space } from 'antd';
import { memo } from 'react';
import Button from '/react4xp/mixins/ui/button/button';

interface FormButtons {
    close: () => void;
    submitLabel?: string;
}

const FormButtons = memo(({ close, submitLabel = 'Сохранить' }: FormButtons) => {
    return (
        <Row justify="end">
            <Space>
                <Form.Item>
                    <Button onClick={close}>Отменить</Button>
                </Form.Item>
                <Form.Item>
                    <Button
                        htmlType="submit"
                        color="gold"
                    >
                        {submitLabel}
                    </Button>
                </Form.Item>
            </Space>
        </Row>
    );
});

export default FormButtons;
